export interface ArticleSection {
  type: 'paragraph' | 'heading' | 'list';
  content: string;
  items?: string[];
}

export interface Article {
  id: string;
  comicId: string;
  title: string;
  author: string;
  publishDate: string;
  category: string;
  coverImage: string;
  summary: string;
  sections: ArticleSection[];
  tags: string[];
  relatedComicIds: string[];
  rating: number;
  views: number;
}

export const articles: Article[] = [
  {
    id: 'article-1',
    comicId: 'comic-1',
    title: '《她的秘密花园》— 2026年最值得追的韩国恋爱漫画深度评测',
    author: '漫画评论员小明',
    publishDate: '2026-08-03',
    category: 'romance',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20style%20illustration%20of%20a%20young%20woman%20in%20a%20secret%20garden%20with%20flowers%2C%20soft%20romantic%20atmosphere%2C%20pastel%20colors%2C%20delicate%20linework%2C%20Korean%20webtoon%20art%20style%2C%20dreamy%20lighting%2C%20slightly%20mysterious%20mood%2C%20clean%20composition%20on%20light%20cream%20background&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    summary: '金智慧作家的《她的秘密花园》已经成为2026年韩国漫画界的现象级作品。本文从剧情、画风、人物塑造等多个维度进行深度评测，带你全面了解这部浪漫佳作的魅力所在。',
    sections: [
      { type: 'heading', content: '剧情概述' },
      { type: 'paragraph', content: '《她的秘密花园》讲述了平凡女孩林素熙在城市老城区偶然发现一座被遗忘的秘密花园，并在那里遇见了神秘的花园主人姜泰俊。随着故事推进，素熙发现这座花园不仅隐藏着泰俊家族的秘密，更与自己已故的母亲有着千丝万缕的联系。' },
      { type: 'heading', content: '人物塑造分析' },
      { type: 'paragraph', content: '女主角林素熙的人设摆脱了传统恋爱漫画中"傻白甜"的刻板印象。她聪明、独立，面对感情时既勇敢又保有理性思考。而男主角姜泰俊则被塑造成一个外表冷峻但内心温暖的形象，他的成长弧光令人印象深刻。' },
      { type: 'heading', content: '画风与视觉表现' },
      { type: 'paragraph', content: '金智慧作家的画风以细腻著称，尤其是在描绘花园场景时，每一朵花、每一片叶子都充满了生命力。色彩的运用格外讲究——冷色调表现主角内心的孤独，暖色调则渲染恋爱时的甜蜜氛围。' },
      { type: 'heading', content: '为什么这部作品值得推荐' },
      { type: 'list', content: '', items: ['剧情节奏把控精准，每话结尾都留有悬念，让人忍不住想看下一话', '人物关系发展自然，不靠狗血误会推动剧情', '画风精美，每一格都可以截图做壁纸', '情感描写真实细腻，容易引起读者共鸣', '世界观构建完整，花园的设定充满想象力'] },
      { type: 'heading', content: '总结' },
      { type: 'paragraph', content: '《她的秘密花园》是一部值得反复品味的佳作。它不仅有甜蜜的恋爱线，更有关于家庭、成长和治愈的深层主题。无论你是韩国漫画的老读者还是新人，这部作品都值得加入你的追更列表。评分：4.8/5.0。' },
    ],
    tags: ['韩国漫画', '恋爱漫画', '漫画推荐', '她的秘密花园', '金智慧'],
    relatedComicIds: ['comic-7', 'comic-12'],
    rating: 4.8,
    views: 35800,
  },
  {
    id: 'article-2',
    comicId: 'comic-5',
    title: '《咖啡与猫》完结纪念 — 一部治愈了百万人心的韩国日常漫画',
    author: '韩漫观察员',
    publishDate: '2026-08-02',
    category: 'slice-of-life',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20slice%20of%20life%20illustration%20of%20a%20cozy%20cat%20cafe%20with%20a%20young%20woman%20and%20cats%2C%20warm%20sunlight%2C%20Korean%20webtoon%20style%2C%20soft%20pastel%20colors%2C%20peaceful%20atmosphere%2C%20clean%20composition%20on%20cream%20background&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    summary: '尹秀雅作家的《咖啡与猫》在连载两年后迎来了圆满结局。这部以猫咪咖啡馆为舞台的日常漫画，用68话的篇幅温暖了超过150万读者的心灵。',
    sections: [
      { type: 'heading', content: '故事背景' },
      { type: 'paragraph', content: '《咖啡与猫》的故事围绕着首尔一条安静小巷中的猫咪咖啡馆"尾尾咖啡"展开。店主秀雅和她的四只猫咪——拿铁、摩卡、卡布奇诺和美式，每天迎接着形形色色的客人，每个客人都带着自己的故事走进这家温暖的咖啡馆。' },
      { type: 'heading', content: '治愈的力量' },
      { type: 'paragraph', content: '这部作品最大的魅力在于它的"治愈力"。尹秀雅作家擅长用简单的日常场景传递深刻的情感——一杯热咖啡、猫咪的一个懒腰、陌生人的一句问候，都能成为治愈人心的力量。许多读者留言说，在疲惫的一天后看一话《咖啡与猫》，就像真的去了一趟猫咪咖啡馆。' },
      { type: 'heading', content: '完结评价' },
      { type: 'paragraph', content: '68话的篇幅不长不短，恰到好处。结局温暖圆满但不刻意，每个角色的故事线都得到了妥善收尾。虽然粉丝们不舍得告别，但正如作品传达的理念——美好的事物终有结束时，重要的是珍惜相遇的每一刻。' },
      { type: 'heading', content: '推荐理由' },
      { type: 'list', content: '', items: ['完美的日常治愈系漫画，适合压力大时放松阅读', '猫咪画得非常可爱生动，爱猫人士必看', '每话独立又相互关联，随时可以拿起阅读', '温暖但不煽情，治愈但不鸡汤', '已经完结，可以一口气看完'] },
    ],
    tags: ['韩国漫画', '治愈漫画', '猫咪', '咖啡与猫', '尹秀雅', '完结推荐'],
    relatedComicIds: ['comic-10', 'comic-5'],
    rating: 4.9,
    views: 42100,
  },
  {
    id: 'article-3',
    comicId: 'comic-8',
    title: '《神之塔：重生》— 韩国奇幻漫画的新标杆',
    author: '奇幻漫画迷',
    publishDate: '2026-07-28',
    category: 'fantasy',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20fantasy%20action%20illustration%20of%20a%20character%20climbing%20a%20mysterious%20tower%20with%20magical%20energy%2C%20epic%20scale%2C%20Korean%20webtoon%20style%2C%20vibrant%20colors%2C%20dramatic%20perspective%2C%20clean%20composition&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    summary: '郑恩秀作家的《神之塔：重生》以其宏大的世界观和精妙的战斗系统，成为韩国奇幻漫画领域的新标杆，累计阅读量突破210万。',
    sections: [
      { type: 'heading', content: '世界观构建' },
      { type: 'paragraph', content: '《神之塔：重生》的世界观堪称韩国漫画中的顶级水准。神之塔共有100层，每一层都是一个独立的小世界，拥有不同的规则、生态和挑战。从冰雪覆盖的第23层到火焰弥漫的第57层，每一层的场景设计都充满想象力。' },
      { type: 'heading', content: '战斗系统' },
      { type: 'paragraph', content: '本作的战斗系统基于"神力"概念，每位登塔者都拥有独特的神力属性。战斗不仅是力量的较量，更是策略和智慧的对决。郑恩秀作家对每场战斗的设计都经过精心考量，没有一场战斗是重复或无聊的。' },
      { type: 'heading', content: '角色成长' },
      { type: 'paragraph', content: '主角从一名弱小的登塔者逐步成长为强者，这一过程并非靠"开挂"，而是经历了无数次失败、挫折和反思。配角们也各具特色，没有沦为推动剧情的工具人。' },
      { type: 'heading', content: '入门建议' },
      { type: 'list', content: '', items: ['建议从第1话开始追起，世界观需要逐步理解', '前期节奏稍慢，但30话后剧情全面展开', '注意记住主要角色的神力属性，有助于理解战斗', '每周五更新，是目前最稳定的连载之一'] },
    ],
    tags: ['韩国漫画', '奇幻漫画', '神之塔', '郑恩秀', '战斗漫画'],
    relatedComicIds: ['comic-8', 'comic-3'],
    rating: 4.8,
    views: 51200,
  },
  {
    id: 'article-4',
    comicId: 'comic-4',
    title: '烧脑推荐：《第七个目击者》— 让你猜不到结局的韩国悬疑漫画',
    author: '推理爱好者',
    publishDate: '2026-07-25',
    category: 'thriller',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20thriller%20illustration%20of%20a%20detective%20in%20a%20dark%20alley%20with%20rain%2C%20mysterious%20noir%20atmosphere%2C%20Korean%20webtoon%20style%2C%20cool%20blueish%20tones%2C%20dramatic%20shadows%2C%20suspenseful%20mood%2C%20clean%20composition%20on%20dark%20gray%20background&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    summary: '崔正宇的《第七个目击者》是今年最烧脑的悬疑漫画之一。42话的篇幅中，每话都在推翻读者的推理，直到最后一页才揭晓真相。',
    sections: [
      { type: 'heading', content: '案件设定' },
      { type: 'paragraph', content: '故事以一桩发生在首尔江南区的密室杀人案开局。死者是一家科技公司的CEO，现场没有留下任何物证。但在案发当晚，有七个人声称自己目击了案件——然而七个人的证词完全矛盾。' },
      { type: 'heading', content: '叙事手法' },
      { type: 'paragraph', content: '崔正宇采用了独特的"罗生门"式叙事结构。每一话从一个目击者的视角展开，读者跟随刑警金泰浩逐步还原真相。这种叙事方式不仅增加了悬疑感，更让读者深刻体会到"每个人的记忆都经过主观加工"这一主题。' },
      { type: 'heading', content: '反转设计' },
      { type: 'paragraph', content: '毫不夸张地说，这部漫画的反转设计达到了韩国悬疑漫画的顶级水平。当读者觉得已经猜到了真相时，下一话就会用一个精妙的反转让所有推理化为泡影。这种阅读体验令人上瘾。' },
      { type: 'heading', content: '阅读建议' },
      { type: 'list', content: '', items: ['不要跳着看，每话都包含关键线索', '建议一口气看完，细节之间关联紧密', '注意每话中刑警金泰浩的推理过程变化', '看完后可以重读，会有全新的发现'] },
    ],
    tags: ['韩国漫画', '悬疑漫画', '推理', '第七个目击者', '崔正宇'],
    relatedComicIds: ['comic-4', 'comic-9'],
    rating: 4.5,
    views: 28400,
  },
  {
    id: 'article-5',
    comicId: 'comic-12',
    title: '《画中仙》：当传统水墨遇见现代韩国漫画',
    author: '艺术评论人',
    publishDate: '2026-07-20',
    category: 'drama',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20historical%20fantasy%20illustration%20of%20a%20beautiful%20woman%20in%20traditional%20hanbok%20emerging%20from%20a%20painting%2C%20ethereal%20atmosphere%2C%20Korean%20webtoon%20style%2C%20ink%20wash%20painting%20aesthetic%2C%20soft%20colors%2C%20clean%20composition&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    summary: '李美娜作家的《画中仙》是一部在视觉艺术上极具突破性的作品，将传统水墨画的美学意境与现代韩国漫画的叙事手法完美融合。',
    sections: [
      { type: 'heading', content: '艺术风格' },
      { type: 'paragraph', content: '《画中仙》最引人注目的是它独特的视觉风格。李美娜大胆地将传统水墨画的留白、皴法和渲染技法融入漫画创作中。仙女从画中走出的场景采用了水墨晕染的渐变效果，令人叹为观止。' },
      { type: 'heading', content: '剧情介绍' },
      { type: 'paragraph', content: '故事围绕一幅收藏于首尔国立中央博物馆的古代仕女图展开。美术修复师韩在宇在修复过程中意外唤醒了画中仙女素月，两人展开了一段跨越千年的爱情故事。作品在古与今之间游走，探讨了艺术、记忆与永恒的主题。' },
      { type: 'heading', content: '文化价值' },
      { type: 'paragraph', content: '这部作品不仅是一部优秀的漫画，更是韩国传统文化现代演绎的典范。通过漫画这一年轻化的媒介，让更多年轻人对传统艺术产生了兴趣。多所韩国大学的美术系甚至将其列为推荐阅读材料。' },
      { type: 'heading', content: '推荐理由' },
      { type: 'list', content: '', items: ['视觉风格独树一帜，每一格都是艺术品', '故事融合古今，情感真挚动人', '对传统文化的现代诠释令人耳目一新', '画风和故事双在线，是韩国漫画中的精品'] },
    ],
    tags: ['韩国漫画', '古风漫画', '画中仙', '李美娜', '水墨风格'],
    relatedComicIds: ['comic-12', 'comic-1'],
    rating: 4.9,
    views: 39600,
  },
  {
    id: 'article-6',
    comicId: 'comic-2',
    title: '热血沸腾！《剑与王冠》战斗场面全解析',
    author: '动作漫画达人',
    publishDate: '2026-07-15',
    category: 'action',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20action%20illustration%20of%20a%20warrior%20holding%20a%20sword%20with%20a%20golden%20crown%20in%20the%20background%2C%20epic%20fantasy%20style%2C%20dramatic%20lighting%2C%20Korean%20webtoon%20art%2C%20intense%20expression%2C%20royal%20red%20and%20gold%20color%20scheme%2C%20clean%20composition%20on%20dark%20background&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    summary: '朴武镇作家的《剑与王冠》拥有韩国动作漫画中最出色的战斗分镜设计。本文带你逐一解析其中的经典战役场景。',
    sections: [
      { type: 'heading', content: '动作分镜艺术' },
      { type: 'paragraph', content: '朴武镇的动作分镜被韩国漫画界称为"教科书级别"。他善于利用倾斜的构图、速度线和动态模糊来表现战斗的激烈感。每一次剑锋相交的瞬间都充满了力量感和视觉冲击力。' },
      { type: 'heading', content: '经典战役回顾' },
      { type: 'paragraph', content: '作品中最令人难忘的是第56话的"王城之战"。主角单枪匹马闯入已被叛军占领的王城，在暴风雨中与敌方将领展开了一场长达三话的决斗。这场战斗不仅动作设计精彩，情感渲染也达到了顶峰。' },
      { type: 'heading', content: '战斗与叙事的平衡' },
      { type: 'paragraph', content: '与其他纯战斗漫画不同，《剑与王冠》的每一场战斗都服务于剧情和角色成长。战斗不是目的，而是角色表达自我、实现蜕变的舞台。这使得读者在享受精彩打斗的同时，也能感受到故事的深度。' },
      { type: 'heading', content: '入坑指南' },
      { type: 'list', content: '', items: ['前20话是世界观铺垫，耐心看下去会有惊喜', '战斗场面建议在大屏幕上观看，手机屏幕会损失细节', '关注朴武镇对冷兵器战斗的研究，很多动作有真实武术基础', '目前已连载124话，是稳定更新的长篇作品'] },
    ],
    tags: ['韩国漫画', '动作漫画', '剑与王冠', '朴武镇', '战斗解析'],
    relatedComicIds: ['comic-2', 'comic-11'],
    rating: 4.6,
    views: 33200,
  },
];

export const getArticleById = (id: string): Article | undefined => {
  return articles.find((a) => a.id === id);
};

export const getArticlesByCategory = (slug: string): Article[] => {
  return articles.filter((a) => a.category === slug);
};

export const getRelatedArticles = (article: Article): Article[] => {
  return article.relatedComicIds
    .map((cid) => articles.find((a) => a.comicId === cid && a.id !== article.id))
    .filter((a): a is Article => a !== undefined);
};